// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-widget-settings .widget-settings-block-padding {
  padding: 10px;
}
.fi-widget-settings .all-languages-toggle {
  background: none;
  border: 1px solid transparent;
  color: var(--fi-color-light);
  border-radius: 100%;
  width: 40px;
  height: 40px;
  min-width: 40px;
  text-align: center;
  padding: 0;
  line-height: 45px;
  font-size: 20px;
}
.fi-widget-settings .content-header .header-languages {
  position: relative;
}
.fi-widget-settings .content-header .header-languages .all-languages-toggle {
  display: block;
  float: right;
}
.fi-widget-settings .content-header .header-languages .language {
  width: 100%;
}
.fi-widget-settings .content-header .header-languages .language[hidden] {
  display: none;
}
.fi-widget-settings .content-settings {
  margin-top: 10px;
}
.fi-widget-settings .widget-settings-checkbox-list > mat-checkbox {
  font-size: 13px;
  display: block;
}
.fi-widget-settings .widget-settings-checkbox-list > md-checkbox {
  font-size: 13px;
}
.fi-widget-settings .widget-settings-checkbox-list > md-checkbox + md-checkbox {
  margin-top: 4px;
}
.fi-widget-settings .widget-settings-radio-list > md-radio-button,
.fi-widget-settings .widget-settings-radio-list > mat-radio-button {
  font-size: 13px;
  margin-bottom: 0;
}
.fi-widget-settings .widget-settings-radio-list > md-radio-button + md-radio-button,
.fi-widget-settings .widget-settings-radio-list > md-radio-button + mat-radio-button,
.fi-widget-settings .widget-settings-radio-list > mat-radio-button + md-radio-button,
.fi-widget-settings .widget-settings-radio-list > mat-radio-button + mat-radio-button {
  margin-top: 4px;
}
.fi-widget-settings .widget-list-settings > div {
  margin-bottom: 20px;
}
.fi-widget-settings .widget-list-settings .TagsContainer {
  position: relative;
}
.fi-widget-settings .widget-settings-group-header {
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./Source/app/widget-settings/widget-settings.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;AAAR;AAGI;EACI,gBAAA;EACA,6BAAA;EACA,4BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;AADR;AAKQ;EACI,kBAAA;AAHZ;AAIY;EACI,cAAA;EACA,YAAA;AAFhB;AAKY;EACI,WAAA;AAHhB;AAKgB;EACI,aAAA;AAHpB;AASI;EACI,gBAAA;AAPR;AAWQ;EACI,eAAA;EACA,cAAA;AATZ;AAYQ;EACI,eAAA;AAVZ;AAYY;EACI,eAAA;AAVhB;AAgBQ;;EAEI,eAAA;EACA,gBAAA;AAdZ;AAgBY;;;;EAEI,eAAA;AAZhB;AAkBQ;EACI,mBAAA;AAhBZ;AAmBQ;EACI,kBAAA;AAjBZ;AAqBI;EACI,mBAAA;AAnBR","sourcesContent":[".fi-widget-settings {\r\n    .widget-settings-block-padding {\r\n        padding: 10px;\r\n    }\r\n\r\n    .all-languages-toggle {\r\n        background: none;\r\n        border: 1px solid transparent;\r\n        color: var(--fi-color-light);\r\n        border-radius: 100%;\r\n        width: 40px;\r\n        height: 40px;\r\n        min-width: 40px;\r\n        text-align: center;\r\n        padding: 0;\r\n        line-height: 45px;\r\n        font-size: 20px;\r\n    }\r\n\r\n    .content-header {\r\n        .header-languages {\r\n            position: relative;\r\n            .all-languages-toggle {\r\n                display: block;\r\n                float: right;\r\n            }\r\n\r\n            .language {\r\n                width: 100%;\r\n\r\n                &[hidden] {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .content-settings {\r\n        margin-top: 10px;\r\n    }\r\n\r\n    .widget-settings-checkbox-list {\r\n        > mat-checkbox {\r\n            font-size: 13px;\r\n            display: block;\r\n        }\r\n\r\n        > md-checkbox {\r\n            font-size: 13px;\r\n\r\n            + md-checkbox {\r\n                margin-top: 4px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .widget-settings-radio-list {\r\n        > md-radio-button,\r\n        > mat-radio-button {\r\n            font-size: 13px;\r\n            margin-bottom: 0;\r\n\r\n            + md-radio-button,\r\n            + mat-radio-button {\r\n                margin-top: 4px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .widget-list-settings {\r\n        > div {\r\n            margin-bottom: 20px;\r\n        }\r\n\r\n        .TagsContainer {\r\n            position: relative;\r\n        }\r\n    }\r\n\r\n    .widget-settings-group-header {\r\n        margin-bottom: 10px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
